// extracted by mini-css-extract-plugin
export var actions = "_4m-0";
export var actionsContainer = "_4m-7";
export var border = "_4m-1";
export var childFullHeight = "_4m-e";
export var collapse = "_4m-2";
export var content = "_4m-9";
export var contentChild = "_4m-d";
export var fullscreen = "_4m-b";
export var hasLeftRadius = "_4m-q";
export var headerContainer = "_4m-3";
export var headerRow = "_4m-5";
export var hidePadding = "_4m-a";
export var navCollapsedGap = "_4m-r";
export var noScrollX = "_4m-s";
export var noScrollY = "_4m-t";
export var noTopPadding = "_4m-o";
export var optOutTopPadding = "_4m-c";
export var outletContent = "_4m-k";
export var outletContentInner = "_4m-l";
export var outletLeadingPanel = "_4m-h";
export var outletLeadingPanelAttention = "_4m-i";
export var outletResizeDivider = "_4m-j";
export var outletSplit = "_4m-f";
export var outletSplitResizing = "_4m-g";
export var pageMain = "_4m-p";
export var pageOuter = "_4m-m";
export var pagePadding = "_4m-8";
export var profile = "_4m-u";
export var profileContainer = "_4m-v";
export var profileImage = "_4m-w";
export var profileMain = "_4m-x";
export var profileSubtitle = "_4m-z";
export var profileTitle = "_4m-y";
export var showLeftPadding = "_4m-n";
export var tabsPortalSlot = "_4m-6";
export var tabsWrapper = "_4m-4";
export var title = "_4m-10";